// Port of api/fuel/app/classes/controller/api/monty/session/boosts.php
import Constants from 'offline/constants'
import DB from 'offline/db'

function userId(params) {
	return params.sessionUserId || DB.meta('sync_user_id') || false
}

export default function(params) {
	var method = params.__offlineMethod || 'GET'
	var uid = userId(params)

	if (!uid) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	if (method !== 'GET') {
		return Promise.reject({ error: 'This action is not available offline.', offline: true })
	}

	var rows = DB.query(
		'SELECT * FROM platform_boost WHERE user_id = ? AND boost_type = ? ORDER BY boost_date DESC LIMIT 1',
		[uid, Constants.TYPE_GROUP]
	)
	var boost = rows.length ? rows[0] : false

	return Promise.resolve({
		session: { offline: true },
		data: {
			canRemoveGroup: boost ? parseInt(boost.boost_date, 10) < (Math.floor(Date.now() / 1000) - Constants.TIME_WEEK) : false,
			groupDate: boost ? parseInt(boost.boost_date, 10) + Constants.TIME_WEEK : false,
			canGroup: false,
			group: boost ? parseInt(boost.boost_recipient, 10) : false,
			ready: boost ? parseInt(boost.boost_status, 10) : false
		}
	})
}
